import { GiAmericanFootballHelmet, GiEternalLove, GiChocolateBar, GiCarDoor } from 'react-icons/gi';

export default [
/*{
        link: "",
        title: "",
        desc: "",
        pic: "" INCLUDE ALT TEXT!!!,
        tag: "" - Development, Published, Story, Life Charge
    }*/

    {
        link: "/articles/amazon-and-al-capone",
        title: "Amazon and Al Capone",
        desc: "Al Capone's booze racket seemed unstoppable in the 1930s. Who would have thought they nailed him with tax evasion? Amazon might be taken down in the same unexpected manner.",
        pic: <img src="https://live.staticflickr.com/65535/50897829381_c8d201a5ee_c.jpg" style={{height: "3em", marginLeft: "40%"}} alt="Car in the 1930s during Prohibition."/>,
        tag: "Published"
    },
    {
        link: "/articles/by-any-other-name",
        title: "By Any Other Name",
        desc: "Peace with Israel and the Arab states mean our entire region can coalesce into a huge economic powerhouse, even if, like Europe, we all maintain our unique language, culture, cuisine, and religion. But what will we call it?",
        pic: <img src="https://live.staticflickr.com/65535/50873725431_488d9d75bf_c.jpg" style={{height: "3em", marginLeft: "40%"}}/>,
        tag: "Published"
    },
    {
        link: "/articles/a-state-is-born",
        title: "A State is Born",
        desc: "Learning useState() in ReactJS for the first time is like learning how to ride a bike. Next step: Road trip to the ends of the earth and back.",
        pic: <img src="https://live.staticflickr.com/65535/50870085797_f3589da6f2_c.jpg" style={{height: "3em", marginLeft: "40%"}}/>,
        tag: "Development"
    },
    {
        link: "/articles/go-with-God",
        title: "Go with G-d",
        desc: "The real outrage didn't occur on January 6 in the American Congress Building. It occured 3 days eariler. All of us must choose which side we are on. Let's go with G-d!",
        pic: <img src="https://i.imgur.com/g7wB5kI.jpg" style={{height: "3em", marginLeft: "40%"}}/>,
        tag: "Published"
    },
    {
        link: "/articles/put-on-your-helmet",
        title: "Put On Your Helmet",
        desc: "The evolution of a Helmet component from JSX text to a React Component to using props so I don't have to copy and paste my title 3 times anymore.",
        pic: <GiAmericanFootballHelmet style={{color: "green"}} />,
        tag: "Development"
    },
    {
        link: "/articles/the-dating-game",
        title: "Overcoming My Fear of Dating",
        desc: "Here is my journey into the dating game, trying to figure out how to use the Date() Object and apply what I want to see onto Highway 60.",
        pic: <GiEternalLove style={{color: "red"}}/>,
        tag: "Development"
    },
    {
        link: "/articles/a-big-decision",
        title: "A Big Decision",
        desc: "Do I render my code or eat a piece of chocolate? To be or not to be.",
        pic: <GiChocolateBar style={{color: "brown"}} />,
        tag: "Story"
    },
    {
        link: "/articles/hello-world",
        title: "Welcome to Highway 60",
        desc: "This is my hello world article. The flagship piece for what Highway 60 is all about.",
        pic: <img src="https://i.imgur.com/SPrG2WA.jpg" style={{height: "3em", marginLeft: "40%"}}/>,
        tag: "Development"
            },

];



